import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {Person} from '../../models/person';

@Component({
  selector:    'ngx-children-selector',
  templateUrl: './children-selector.component.html',
  styleUrls:   ['./children-selector.component.scss'],
})
export class ChildrenSelectorComponent implements OnInit {
  @Input()
  public children: Array<Person>           = [];
  public selectableChildren: Array<Person> = [];
  @Input()
  public selectedChildren: Array<Person>   = [];

  @Output() onCancel: EventEmitter<boolean>         = new EventEmitter();
  @Output() onContinue: EventEmitter<Array<Person>> = new EventEmitter();

  constructor() {

  }

  ngOnInit() {
    this.selectableChildren = this.children.slice(0);
    this.sort();
  }

  selectChild(i, child) {
    this.selectedChildren.push(child);
    this.selectableChildren.splice(i, 1);
    this.sort();
  }

  selectAll() {
    // this.selectedChildren = this.children.slice(0);] // This causes an issue where selectedChildren is blank.
    while (this.selectedChildren.length) {
      this.selectedChildren.pop();
    }
    for (const child of this.children) {
      this.selectedChildren.push(child);
    }
    this.selectableChildren = [];
    this.sort();
  }

  unselectChild(i, child) {
    this.selectableChildren.push(child);
    this.selectedChildren.splice(i, 1);
    this.sort();
  }

  sort() {
    this.selectableChildren.sort((a: Person, b: Person) => {
      return a.first_name.localeCompare(b.first_name);
    })

    this.selectedChildren.sort((a: Person, b: Person) => {
      return a.first_name.localeCompare(b.first_name);
    })

    // this.selectableChildren.sort((n1, n2) => {
    //   return this.naturalCompare(n1.first_name, n2.first_name);
    // })
    //
    // this.selectedChildren.sort((n1, n2) => {
    //   return this.naturalCompare(n1.first_name, n2.first_name);
    // })
  }

  triggerCancel() {
    this.onCancel.emit(true);
  }

  triggerContinue() {
    this.onContinue.emit(this.selectedChildren);
  }

  naturalCompare(a, b) {
    const ax = [], bx = [];

    a.replace(/(\d+)|(\D+)/g, function (_, $1, $2) {
      ax.push([$1 || Infinity, $2 || ''])
    });
    b.replace(/(\d+)|(\D+)/g, function (_, $1, $2) {
      bx.push([$1 || Infinity, $2 || ''])
    });

    while (ax.length && bx.length) {
      const an = ax.shift();
      const bn = bx.shift();
      const nn = (an[0] - bn[0]) || an[1].localeCompare(bn[1]);
      if (nn) return nn;
    }

    return ax.length - bx.length;
  }
}
